import { useRouter } from "next/router";
import React from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";
import { SearchQuery } from "shared/data/reducers/types/storage";

import Checkbox from "@components/UI/Checkbox";
import FormattedMessage from "@components/UI/FormattedMessage";

import { ROUTES } from "@shared/constants";

import FilterTransfers from "./FilterTransfers";
import { getMaxNumTransfers } from "./helpers";

type Props = {
  changeFilter: (e: any) => void;
  query: SearchQuery;
};

const FilterBox1 = ({ query, changeFilter }: Props) => {
  const router = useRouter();

  const { maxNumTransfers } = useSelector((appState: AppState) => ({
    maxNumTransfers: appState.search.maxNumTransfers,
  }));

  const maxTransfers = getMaxNumTransfers(query, maxNumTransfers);

  const isFilterBaggageRequested = query.baggage === "true";

  return (
    <div className="filters-box">
      <span className="filters-label">
        <FormattedMessage id="Filters.numberOfTransfers" />:
      </span>

      <FilterTransfers
        changeFilter={changeFilter}
        propsMaxTransfers={maxNumTransfers}
        maxTransfers={maxTransfers}
      />

      <Checkbox
        customContainerClass="baggage-checkbox-container"
        customLabelClass="baggage-checkbox-label"
        label={<FormattedMessage id="Filters.baggageIncluded" />}
        onClick={() => {
          router.replace(
            {
              pathname: ROUTES.RESULTS,
              query: {
                ...query,
                baggage: isFilterBaggageRequested ? "false" : "true",
              },
            },
            undefined,
            { shallow: true, scroll: false }
          );
        }}
        checked={isFilterBaggageRequested}
      />

      <div className="clearfix" />
    </div>
  );
};

export default FilterBox1;
